import React from "react";
import { ToolRendererProps } from "./types";

export const GrepToolRenderer: React.FC<ToolRendererProps> = ({
  args,
  status,
  toolResult,
  renderWithErrorIfFailed,
  getFallbackText,
  stringifyRender,
}) => {
  const hasNewSchema = typeof args?.pattern === "string";

  if (hasNewSchema) {
    const pattern = args.pattern;
    const searchPath = args.path;
    const globFilter = args.glob;
    const contextLines = args.context_lines;

    return (
      <>
        {renderWithErrorIfFailed(
          <div className="text-xs text-secondary-n-400 space-y-1">
            <div>
              Pattern: <span className="font-mono">{pattern}</span>
            </div>
            {searchPath && (
              <div>
                Path: <span className="font-mono">{searchPath}</span>
              </div>
            )}
            {globFilter && (
              <div>
                Filter: <span className="font-mono">{globFilter}</span>
              </div>
            )}
            {contextLines !== undefined && (
              <div className="text-secondary-n-500">
                Context: ±{contextLines} lines
              </div>
            )}
            {toolResult?.totalMatches !== undefined &&
              status === "succeeded" && (
                <div className="text-secondary-n-500">
                  Found {toolResult.totalMatches}{" "}
                  {toolResult.totalMatches === 1 ? "match" : "matches"}
                </div>
              )}
          </div>,
        )}
      </>
    );
  } else {
    let patterns: string[] = [];
    try {
      patterns = (args?.grepSearchPatterns || []).map(stringifyRender);
    } catch (e) {
      console.error(
        "Failed to stringify grep patterns:",
        e,
        args?.grepSearchPatterns,
      );
      patterns = [];
    }

    return patterns.length > 0
      ? renderWithErrorIfFailed(
          <ul className="list-none">
            {patterns.map((pattern: string, index: number) => (
              <li key={index} className="text-xs text-secondary-n-400">
                {pattern}
              </li>
            ))}
          </ul>,
        )
      : getFallbackText();
  }
};
